import type { DataGridFilterOption, DataGridFilterOptionsPage } from '@ibsys/kit';
import { getShortName } from './string';

/**
 * Время жизни загруженной страницы справочника, из которого асинхронный фильтр DataGrid берёт опции.
 * Фильтр, открытый повторно, показывает список сразу: за минуту состав справочника не меняется.
 */
export const FILTER_OPTIONS_STALE_TIME = 60_000;

/**
 * Человек из справочника (участник диалога, пользователь системы) — то, чего хватает опции фильтра.
 */
export type PersonFilterOptionItem = {
  /** Идентификатор — значение опции */
  id: number;
  firstName?: string | null;
  lastName?: string | null;
  middleName?: string | null;
};

/**
 * Человек из справочника как опция фильтра DataGrid: значение — идентификатор, подпись — фамилия с инициалами.
 */
export const toPersonFilterOption = (person: PersonFilterOptionItem): DataGridFilterOption => ({
  value: person.id,
  label: getShortName(person.firstName, person.lastName, person.middleName),
});

/**
 * Окно ответа справочника как страница опций фильтра DataGrid.
 * Следующая страница есть, пока показанные записи не покрыли весь справочник.
 */
export const toFilterOptionsPage = <TItem>(
  items: TItem[],
  total: number,
  offset: number,
  toOption: (item: TItem) => DataGridFilterOption,
): DataGridFilterOptionsPage => ({
  options: items.map(toOption),
  hasMore: offset + items.length < total,
});
